import React, { useContext, useEffect, useState } from "react";
import { FoundationsButton } from "../../../GenericComponents/button";
import Dialog from "../../../GenericComponents/dialog";
import { useCheckDeleteWorkspaceMutation, useDeleteWorkspaceMutation } from "../../../Redux/Workspace/workspaceActionsSlice";
import { FoundationsGenericToaster } from "../../../GenericComponents/FoundationsGenericToaster";
import { useNavigate } from "react-router-dom";

interface DeleteWorkspaceDialogProps {
    isOpen: boolean;
    onClose: () => void;
    WorkspaceId: string;
    deleteCallback?: any;
}

declare let window: any
const UnicornApp = window.unicornInstance as any


const DeleteWorkspaceDialog: React.FC<DeleteWorkspaceDialogProps> = ({ isOpen, onClose, WorkspaceId, deleteCallback }) => {
    const [deleteWorkspace] = useDeleteWorkspaceMutation();
    const [deleteDialogMessage, setdeleteDialogMessage] = useState('')
    const [checkDeleteWorkspace] = useCheckDeleteWorkspaceMutation()
    const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false)
    const [isSubmitting, setIsSubmitting] = useState(false)
    const navigate = useNavigate();

    useEffect(() => {
        if (isOpen) {
            CheckDeleteWorkspace()
        }
    }, [isOpen])

    const CheckDeleteWorkspace = () => {
        const formData = new FormData()
        formData.append('dashBoardId', WorkspaceId)

        checkDeleteWorkspace(formData)
            .unwrap()
            .then((response) => {
                if (response?.statusCode === 201) {
                    const resultData = response.data
                    if (resultData) {
                        if (!resultData.allowDelete) {
                            const alertMessage =
                                resultData.lockStatus < 2
                                    ? 'Cannot Delete - Workspace lock status changed.'
                                    : 'Cannot Edit - Workspace lock status changed to high security.'
                            setdeleteDialogMessage(alertMessage)
                        } else {
                            let message = `Are you sure you want to delete this workspace </br><strong>permanently</strong>?<br><br><strong>This operation cannot be undone.</strong>`
                            if (resultData.deleteUserDashBoardsCount > 0) {
                                message += `<br><br>This workspace is used by <strong>${resultData.deleteUserDashBoardsCount} other users</strong>.`
                            }
                            setdeleteDialogMessage(message)
                        }
                        setIsDeleteDialogOpen(true);
                    }
                } else if (response?.statusCode === 'OperationNotAllowed') {
                    FoundationsGenericToaster(
                        'error',
                        'Sorry, you do not have permission to complete this operation.'
                    )
                    setIsDeleteDialogOpen(false)
                    onClose(); // Close the dialog if permission is denied
                }
            })
            .catch((error) => {
                console.error('Error checking delete permissions', error)
                setIsDeleteDialogOpen(false)
                onClose(); // Close the dialog if permission is denied
            })
    }

    const handleDeleteWorkspace = () => {
        if (isSubmitting) return; // Prevent multiple submissions
        setIsSubmitting(true); // Disable button after first click

        const formData = new FormData();
        formData.append("dashBoardId", WorkspaceId);

        deleteWorkspace(formData)
            .unwrap()
            .then((response) => {
                try {
                    if (response?.statusCode === 204) {
                        FoundationsGenericToaster("success", "Workspace deleted successfully.");
                        navigate('#home?ref=del_workspace', { replace: true });
                        onClose();

                        if (deleteCallback) {
                            deleteCallback({ WorkspaceId });
                        }
                    } else {
                        throw new Error("Invalid response status");
                    }
                } catch (err) {
                    console.error("Error in then block", err);
                    FoundationsGenericToaster("error", "An unexpected error occurred.");
                }
            })
            .catch((error) => {
                console.error("Error deleting workspace", error);
                if (error?.name !== "HandledError") {
                    FoundationsGenericToaster("error", "An error occurred while deleting the workspace.");
                }
            })
            .finally(() => {
                setIsSubmitting(false);
            });
    };


    return isOpen && isDeleteDialogOpen ? (
        <Dialog isOpen={isOpen}
            title="Delete Workspace"
            onClose={onClose}
            className="left-align-text"
            buttons={[
                {
                    label: "Cancel",
                    id: "cancel-delete-workspace",
                    onClick: onClose,
                    className: "ui-button ui-corner-all ui-widget app-button negative",
                },
                {
                    label: "Delete Workspace",
                    id: "delete-workspace-button",
                    onClick: () => {
                        handleDeleteWorkspace();
                    },
                    className: "ui-button ui-corner-all ui-widget app-button",
                },
            ]}

        >
            <div id="delete_dashboard_dialog_wrapper" className="ui-dialog-content ui-widget-content">
                <div className="panel-popup-window">
                    <div id="delete_dashboard_warning">
                        <p dangerouslySetInnerHTML={{ __html: deleteDialogMessage }}></p>
                    </div>
                </div>
            </div>
        </Dialog>
    ) : null;
}

export default DeleteWorkspaceDialog;